import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, type SxProps, type Theme } from '@mui/material'
import React, { useState } from 'react'

type ConfirmationDialogProps = {
  title: string
  content: React.ReactNode
  onConfirm: () => void
  buttonAriaLabel?: string
  buttonSx?: SxProps<Theme>
}

const ConfirmationDialog = ({ title, content, onConfirm, buttonAriaLabel, buttonSx }: ConfirmationDialogProps) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <Button color="error" aria-label={buttonAriaLabel} onClick={() => setDialogOpen(true)} sx={buttonSx}>
        {content}
      </Button>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Confirm your action</DialogTitle>
        <DialogContent>
          <DialogContentText>{title}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={onConfirm} color="error">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ConfirmationDialog
